import React, { useEffect, useMemo, useState } from "react";
import { MdClose } from "react-icons/md";
import Button from "../../ui/Button";
import Input from "../../ui/Input";
import Toggle from "../../ui/ToggleButton";
import Checkbox from "../../ui/Checkbox";
import { FaCheck, FaChevronDown, FaSpinner } from "react-icons/fa";
import SettingsDropdown from "./SettingsDropdwon";
import { SALARY_TEMP_SHORT_TYPES_MAPPER, DEFAULT_SALARY_TEMPLATE_IN, DEFAULT_SALARY_TEMPLATE_GB } from "../../../constants/settingsConstants";
import useFetch from "../../../hooks/useFetch";
import { useSelector } from "react-redux";
import { selectCid } from "../../../features/companyid";
import CloseUnsaved from "./CloseUnsaved";
import axiosInstance from "../../../axiosInstance";


const SalaryComponent = ({
  item,
  index,
  sectionIndex,
  handleValueChange,
  handleRemoveItem,
  singleSelects,
  setSingleSelects,
}) => {
  const selectChange = (value) => {
    if (value === "basic") {
      setSingleSelects({
        ...singleSelects,
        basic: true,
      });
    } else if (value === "special") {
      setSingleSelects({
        ...singleSelects,
        special: true,
      });
    } else if (value === "sb") {
      setSingleSelects({
        ...singleSelects,
        sb: true,
      });
    }
    if (item.type === "basic") {
      setSingleSelects({
        ...singleSelects,
        basic: false,
      });
    } else if (item.type === "special") {
      setSingleSelects({
        ...singleSelects,
        special: false,
      });
    } else if (item.type === "sb") {
      setSingleSelects({
        ...singleSelects,
        sb: false,
      });
    }
    handleValueChange(sectionIndex, index, "type", value);
  };

  const [isEditing, setIsEditing] = useState(false);
  return isEditing ? (
    <div className="flex items-center text-[10px]">
      <div className="border-r h-12">
        <Input
          value={item.name}
          onChange={(e) =>
            handleValueChange(sectionIndex, index, "name", e.target.value)
          }
          placeholder="Name"
          className={
            "flex-1 border-0 rounded-none !shadow-none focus:outline-none focus-visible:border-0 focus-visible:ring-0"
          }
        />
      </div>
      <SettingsDropdown
        options={[
          {
            label: SALARY_TEMP_SHORT_TYPES_MAPPER.fixed,
            onClick: () => selectChange("fixed"),
          },
          {
            label: SALARY_TEMP_SHORT_TYPES_MAPPER.fromBasic,
            onClick: () => selectChange("fromBasic"),
          },
          {
            label: SALARY_TEMP_SHORT_TYPES_MAPPER.percentage,
            onClick: () => selectChange("percentage"),
          },
          ...[
            !singleSelects.special || item.type === "special"
              ? {
                label: SALARY_TEMP_SHORT_TYPES_MAPPER.special,
                onClick: () => selectChange("special"),
              }
              : false,
          ],
          ...[
            !singleSelects.basic || item.type === "basic"
              ? {
                label: SALARY_TEMP_SHORT_TYPES_MAPPER.basic,
                onClick: () => selectChange("basic"),
              }
              : false,
          ],
          ...[
            !singleSelects.sb || item.type === "sb"
              ? {
                label: SALARY_TEMP_SHORT_TYPES_MAPPER.sb,
                onClick: () => selectChange("sb"),
              }
              : false,
          ],
        ].filter(Boolean)}
        className="w-full h-full flex-1"
        trigger={
          <div className="w-full relative cursor-pointer h-12 flex bg-white px-3 items-center justify-between uppercase text-xs font-medium">
            {SALARY_TEMP_SHORT_TYPES_MAPPER[item.type]} <FaChevronDown />
          </div>
        }
      />
      <div
        className={"flex-1 border-x bg-[#EFF1F5] h-12 flex items-center pl-1"}
      >
        <Toggle
          value={item.is_monthly}
          labelClass={"!text-[10px] uppercase font-medium text-black/50"}
          onChange={(value) =>
            handleValueChange(sectionIndex, index, "is_monthly", value)
          }
        />
      </div>
      <div className={"flex-1 flex items-center bg-[#EFF1F5] h-12"}>
        <p className="text-[10px] text-black/50 font-medium pl-1">
          {item.type === "fixed" || item.type === "special" ? "AMT" : "PERC"}
        </p>
        <Input
          value={item.type === "special" ? "Balancing Amount" : item.value}
          type={item.type === "special" ? "text" : "number"}
          min={0}
          placeholder={item.type === "special" ? "Balancing Amount" : "0.00"}
          onWheel={(e) => e.target.blur()}
          onKeyDown={(e) => {
            const forbiddenKeys = ["+", "-", "=", "e", "E"];
            if (forbiddenKeys.includes(e.key)) {
              e.preventDefault();
            }
          }}
          onChange={(e) =>
            handleValueChange(sectionIndex, index, "value", e.target.value)
          }
          disabled={item.type === "special"}
          className={`flex-1 border-0 !bg-transparent !shadow-none focus:outline-none focus-visible:border-0 focus-visible:ring-0 text-end ${item.type === "special" ? "!text-[8px]" : ""
            }`}
        />
      </div>
      <div className="flex bg-black h-12">
        <Button
          variant="black"
          size="icon"
          className="px-2 py-3.5"
          onClick={() => setIsEditing(false)}
        >
          <FaCheck className="w-3 h-3" />
        </Button>
      </div>
    </div>
  ) : (
    <div className="flex">
      <div className="w-[40%] px-2 py-1 h-12 border-r flex justify-between">
        <div className="flex gap-2 items-center">
          <Checkbox
            value={item.is_selected}
            setValue={() =>
              handleValueChange(
                sectionIndex,
                index,
                "is_selected",
                !item.is_selected,
              )
            }
          />
          <p className="font-bold text-ellipsis line-clamp-1">{item.name}</p>
        </div>
        <div className="flex gap-2">
          <Button
            variant="icon"
            size="icon"
            className="!px-1 !py-1"
            onClick={() => setIsEditing(true)}
          >
            {/* pencil svg */}
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.431 4.01235L9.98759 1.56836C9.90633 1.48709 9.80986 1.42262 9.70369 1.37864C9.59752 1.33465 9.48372 1.31201 9.3688 1.31201C9.25387 1.31201 9.14007 1.33465 9.0339 1.37864C8.92773 1.42262 8.83126 1.48709 8.75001 1.56836L2.00649 8.31243C1.92488 8.39338 1.86019 8.48975 1.81615 8.59593C1.77212 8.70212 1.74964 8.81599 1.75 8.93094V11.3749C1.75 11.607 1.84219 11.8295 2.00629 11.9936C2.17038 12.1577 2.39294 12.2499 2.625 12.2499H5.06899C5.18394 12.2503 5.29781 12.2278 5.404 12.1838C5.51018 12.1397 5.60655 12.075 5.68751 11.9934L12.431 5.24993C12.5123 5.16867 12.5768 5.0722 12.6208 4.96603C12.6647 4.85986 12.6874 4.74606 12.6874 4.63114C12.6874 4.51621 12.6647 4.40242 12.6208 4.29624C12.5768 4.19007 12.5123 4.0936 12.431 4.01235ZM5.06899 11.3749H2.625V8.93094L7.43751 4.11844L9.88149 6.56243L5.06899 11.3749ZM10.5 5.94336L8.05602 3.49993L9.36852 2.18743L11.8125 4.63086L10.5 5.94336Z"
                fill="black"
              />
            </svg>
          </Button>
          <Button
            variant="icon"
            size="icon"
            onClick={() => handleRemoveItem(sectionIndex, index)}
            className="!px-1 !py-1 text-red-500"
          >
            {/* trash svg */}
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.8125 2.625H9.625V2.1875C9.625 1.8394 9.48672 1.50556 9.24058 1.25942C8.99444 1.01328 8.6606 0.875 8.3125 0.875H5.6875C5.3394 0.875 5.00556 1.01328 4.75942 1.25942C4.51328 1.50556 4.375 1.8394 4.375 2.1875V2.625H2.1875C2.07147 2.625 1.96019 2.67109 1.87814 2.75314C1.79609 2.83519 1.75 2.94647 1.75 3.0625C1.75 3.17853 1.79609 3.28981 1.87814 3.37186C1.96019 3.45391 2.07147 3.5 2.1875 3.5H2.625V11.375C2.625 11.6071 2.71719 11.8296 2.88128 11.9937C3.04538 12.1578 3.26794 12.25 3.5 12.25H10.5C10.7321 12.25 10.9546 12.1578 11.1187 11.9937C11.2828 11.8296 11.375 11.6071 11.375 11.375V3.5H11.8125C11.9285 3.5 12.0398 3.45391 12.1219 3.37186C12.2039 3.28981 12.25 3.17853 12.25 3.0625C12.25 2.94647 12.2039 2.83519 12.1219 2.75314C12.0398 2.67109 11.9285 2.625 11.8125 2.625ZM5.25 2.1875C5.25 2.07147 5.29609 1.96019 5.37814 1.87814C5.46019 1.79609 5.57147 1.75 5.6875 1.75H8.3125C8.42853 1.75 8.53981 1.79609 8.62186 1.87814C8.70391 1.96019 8.75 2.07147 8.75 2.1875V2.625H5.25V2.1875ZM10.5 11.375H3.5V3.5H10.5V11.375ZM6.125 5.6875V9.1875C6.125 9.30353 6.07891 9.41481 5.99686 9.49686C5.91481 9.57891 5.80353 9.625 5.6875 9.625C5.57147 9.625 5.46019 9.57891 5.37814 9.49686C5.29609 9.41481 5.25 9.30353 5.25 9.1875V5.6875C5.25 5.57147 5.29609 5.46019 5.37814 5.37814C5.46019 5.29609 5.57147 5.25 5.6875 5.25C5.80353 5.25 5.91481 5.29609 5.99686 5.37814C6.07891 5.46019 6.125 5.57147 6.125 5.6875ZM8.75 5.6875V9.1875C8.75 9.30353 8.70391 9.41481 8.62186 9.49686C8.53981 9.57891 8.42853 9.625 8.3125 9.625C8.19647 9.625 8.08519 9.57891 8.00314 9.49686C7.92109 9.41481 7.875 9.30353 7.875 9.1875V5.6875C7.875 5.57147 7.92109 5.46019 8.00314 5.37814C8.08519 5.29609 8.19647 5.25 8.3125 5.25C8.42853 5.25 8.53981 5.29609 8.62186 5.37814C8.70391 5.46019 8.75 5.57147 8.75 5.6875Z"
                fill="#F63D68"
              />
            </svg>
          </Button>
        </div>
      </div>
      <div className="w-[60%] px-2 py-1 flex bg-[#EFF1F5] items-center justify-between">
        <p className="uppercase text-black/50 text-[10px] font-medium">
          {SALARY_TEMP_SHORT_TYPES_MAPPER[item.type]}
        </p>
        <p className="text-xs font-medium">
          {item.type === "special" ? "" : Number(item?.value)?.toFixed(2)}
        </p>
      </div>
    </div>
  );
};

const SalarySectionComponent = ({
  sectionIndex,
  section,
  handleAddItem,
  handleRemoveItem,
  handleValueChange,
  singleSelects,
  setSingleSelects,
  specialAmount,
  handleSectionNameChange,
}) => {
  const [isSectionNameEditable, setIsSectionNameEditable] = useState(false);

  return (
    <div key={sectionIndex} className="border-b text-sm">
      <h3 className="px-4 py-2 text-[#1570EF] font-semibold capitalize border-b flex gap-1 items-center">
        {isSectionNameEditable ? (
          <input
            type="text"
            value={section.section}
            onChange={(e) =>
              handleSectionNameChange(sectionIndex, e.target.value)
            }
            maxLength={20}
            className="px-2 py-1 border border-gray-300 rounded-md"
          />
        ) : (
          section.section
        )}{" "}
        <Button
          variant="icon"
          size="icon"
          onClick={() => setIsSectionNameEditable(!isSectionNameEditable)}
          className="!py-0 !px-1"
        >
          {!isSectionNameEditable ? (
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.431 4.01235L9.98759 1.56836C9.90633 1.48709 9.80986 1.42262 9.70369 1.37864C9.59752 1.33465 9.48372 1.31201 9.3688 1.31201C9.25387 1.31201 9.14007 1.33465 9.0339 1.37864C8.92773 1.42262 8.83126 1.48709 8.75001 1.56836L2.00649 8.31243C1.92488 8.39338 1.86019 8.48975 1.81615 8.59593C1.77212 8.70212 1.74964 8.81599 1.75 8.93094V11.3749C1.75 11.607 1.84219 11.8295 2.00629 11.9936C2.17038 12.1577 2.39294 12.2499 2.625 12.2499H5.06899C5.18394 12.2503 5.29781 12.2278 5.404 12.1838C5.51018 12.1397 5.60655 12.075 5.68751 11.9934L12.431 5.24993C12.5123 5.16867 12.5768 5.0722 12.6208 4.96603C12.6647 4.85986 12.6874 4.74606 12.6874 4.63114C12.6874 4.51621 12.6647 4.40242 12.6208 4.29624C12.5768 4.19007 12.5123 4.0936 12.431 4.01235ZM5.06899 11.3749H2.625V8.93094L7.43751 4.11844L9.88149 6.56243L5.06899 11.3749ZM10.5 5.94336L8.05602 3.49993L9.36852 2.18743L11.8125 4.63086L10.5 5.94336Z"
                fill="black"
              />
            </svg>
          ) : (
            <FaCheck />
          )}
        </Button>
      </h3>
      {sectionIndex === 0 && (
        <>
          <h3 className="px-4 py-2 text-black/50 font-medium capitalize border-b">
            Salary Components included in CTC Calculation
          </h3>
          <h3 className="px-4 py-2 text-black/50 font-normal italic capitalize border-b">
            Check the box to include in CTC calculation
          </h3>
        </>
      )}
      {sectionIndex === 2 && (
        <>
          <h3 className="px-4 py-2 text-black/50 font-medium capitalize border-b">
            Salary Components added to CTC for Total Compensation
          </h3>
          <h3 className="px-4 py-2 text-black/50 font-normal italic capitalize border-b">
            Check the box to include in Total Compensation calculation
          </h3>
        </>
      )}
      <div className="divide-y">
        {section.items.map((item, itemIndex) => (
          <SalaryComponent
            key={itemIndex}
            index={itemIndex}
            item={item}
            sectionIndex={sectionIndex}
            handleValueChange={handleValueChange}
            handleRemoveItem={handleRemoveItem}
            singleSelects={singleSelects}
            setSingleSelects={setSingleSelects}
            specialValue={specialAmount}
          />
        ))}
        <div className="px-4 py-3">
          <Button
            variant="secondary"
            onClick={() => handleAddItem(sectionIndex)}
          >
            Add New Comp
          </Button>
        </div>
      </div>
    </div>
  );
};

const SalaryModal = ({ onClose, data, isEdit, uuid, companyCountryCode }) => {
  const defaultTemplate = companyCountryCode === "GB" ? DEFAULT_SALARY_TEMPLATE_GB : DEFAULT_SALARY_TEMPLATE_IN;
  const [sections, setSections] = useState(data && data.length > 0 ? data : defaultTemplate);
  const [totalCtc, setTotalCtc] = useState(1000000);
  const [name, setName] = useState("New salary template");
  const [closeConfirmationModal, setCloseConfirmationModal] = useState(false);

  const cid = useSelector(selectCid);

  const formatCurrency = (value) => {
    const n = Number.isFinite(value) ? Math.floor(value) : 0;
    const locale = companyCountryCode === "GB" ? "en-GB" : "en-IN";
    return new Intl.NumberFormat(locale).format(n);
  };

  const { refetch } = useFetch(
    "/v2/template/create",
    {
      method: "POST",
      data: {
        type: "salary",
        companyid: cid,
        salary_template: {
          name: name,
          sections: sections,
        },
      },
    },
    false,
  );

  const {
    refetch: getTemplate,
    data: template,
    isLoading,
  } = useFetch(
    "/v2/template/get/" + uuid + "/" + cid,
    {
      method: "GET",
    },
    false,
  );

  const { refetch: updateRefetch } = useFetch(
    "/v2/template/update",
    {
      method: "PATCH",
      data: {
        type: "salary",
        companyid: cid,
        sections: sections,
        uuid: uuid,
        name: name,
      },
    },
    false,
  );

  useEffect(() => {
    if (uuid) {
      getTemplate();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uuid]);

  useEffect(() => {
    if (template && isEdit) {
      setSections(template?.sections || defaultTemplate);
      setName(template?.name || "New salary template");
    }
  }, [isEdit, template, defaultTemplate]);

  /**
   * computeValues helper:
   * - Basic is calculated directly from numericTotalCtc and kept fixed (not proportionally scaled).
   * - Other ctc items (first 2 sections excluding basic & special) are scaled down proportionally if needed to keep CTC breakup <= Sample CTC.
   * - Special picks up remaining amount (if any).
   */
  const computedSections = useMemo(() => {
    const numericTotalCtc = Number(totalCtc) || 0;

    // find basic item (first encountered selected basic)
    let basicItem = null;
    let basicPresent = false;
    let specialPresent = false;
    let specialAmount = 0;
    let sbItem = null;
    let sbPresent = false;
    sections.forEach((sec) => {
      sec.items.forEach((it) => {
        if (it.is_selected) {
          if (it.type === "basic") {
            basicItem = it;
            basicPresent = true;
          }
          if (it.type === "special") {
            specialPresent = true;
          }
          if (it.type === "sb") {
            sbItem = it;
            sbPresent = true;
          }
        }
      });
    });

    const sbAnnualRaw = sbItem
      ? (numericTotalCtc * (Number(sbItem.value) || 0)) / 100
      : 0;

    // helper: raw compute (unscaled)
    const computeValueRaw = (
      item,
      is_monthly = false,
      numericCtc = numericTotalCtc,
      basicItemLocal = basicItem,
      sbAnnual = sbAnnualRaw,
    ) => {
      const multiplier = is_monthly ? 1 / 12 : 1;
      const val = Number(item.value) || 0;

      // Use numericTotalCtc - SB as the base for Gross components (type percentage or basic)
      const effectiveGross = Math.max(0, numericTotalCtc - sbAnnual);

      switch (item.type) {
        case "percentage":
          return effectiveGross * (val / 100) * multiplier;
        case "fixed":
          return val * multiplier;
        case "fromBasic":
          if (!basicItemLocal) return 0;
          const basicAnnual =
            (effectiveGross * (Number(basicItemLocal.value) || 0)) / 100;
          return basicAnnual * (val / 100) * multiplier;
        case "basic":
          return effectiveGross * (val / 100) * (is_monthly ? 1 / 12 : 1);
        case "sb":
          return ((numericCtc * val) / 100) * (is_monthly ? 1 / 12 : 1);
        case "special":
          return 0;
        default:
          return 0;
      }
    };

    // Build initial computed (raw) and track sums for first two sections (CTC bucket)
    const initial = sections.map((section, sIdx) => {
      let sectionTotalAnnual = 0;
      let sectionTotalMonthly = 0;

      const items = section.items
        .filter((it) => it.is_selected)
        .map((it) => {
          if (it.type === "special") {
            return { ...it, monthly: null, annual: 0 };
          }

          const annual = computeValueRaw(it, false);
          const monthly = it.is_monthly ? computeValueRaw(it, true) : null;

          sectionTotalAnnual += annual;
          sectionTotalMonthly += monthly || 0;

          return { ...it, annual, monthly };
        });

      return {
        ...section,
        items,
        sectionTotalAnnual,
        sectionTotalMonthly,
      };
    });

    const effectiveGrossAnnual = Math.max(0, numericTotalCtc - sbAnnualRaw);

    // Determine basicAnnual directly from effectiveGrossAnnual
    const basicAnnualRaw = basicItem
      ? (effectiveGrossAnnual * (Number(basicItem.value) || 0)) / 100
      : 0;
    const finalBasicAnnual = basicAnnualRaw;
    const finalSBAnnual = sbAnnualRaw;
    // Compute "others" sum for first 2 sections excluding basic & special
    const othersRawCtcTotal = initial.slice(0, 2).reduce((acc, sec) => {
      return (
        acc +
        sec.items.reduce((sAcc, it) => {
          if (it.type === "basic" || it.type === "special" || it.type === "sb")
            return sAcc;
          return sAcc + (it.annual || 0);
        }, 0)
      );
    }, 0);

    // The target for Section 0 & 1 (Gross components) is now TotalCtc - SB
    const targetGrossAnnual = Math.max(0, numericTotalCtc - sbAnnualRaw);

    // Now ensure: basicAnnualAfterSB + othersRawCtcTotal <= targetGrossAnnual
    // If > targetGrossAnnual, scale down the "others" proportionally; basic stays as-is (or clamped).
    let scaled = initial.map((sec) => ({ ...sec }));

    if (finalBasicAnnual >= effectiveGrossAnnual) {
      // Basic alone consumes entire available Gross -> clamp basic to targetGrossAnnual, others 0
      const finalBasicClamped = effectiveGrossAnnual;

      scaled = scaled.map((sec, sIdx) => {
        if (sIdx < 2) {
          const newItems = sec.items.map((it) => {
            if (it.type === "basic") {
              const monthly = it.is_monthly ? finalBasicClamped / 12 : null;
              return { ...it, annual: finalBasicClamped, monthly };
            }
            if (it.type === "sb") {
              const monthly = it.is_monthly ? finalSBAnnual / 12 : null;
              return { ...it, annual: finalSBAnnual, monthly };
            }
            // other ctc items become zero
            return { ...it, annual: 0, monthly: null };
          });
          const sumAnn = (a, i) => a + (i.annual || 0);
          const sumMon = (a, i) => a + (i.monthly || 0);
          return {
            ...sec,
            items: newItems,
            sectionTotalAnnual: newItems.reduce(sumAnn, 0),
            sectionTotalMonthly: newItems.reduce(sumMon, 0),
          };
        }
        return sec;
      });
    } else {
      // available for others
      const availableForOthers = Math.max(
        0,
        targetGrossAnnual - finalBasicAnnual,
      );
      if (othersRawCtcTotal > 0 && othersRawCtcTotal > availableForOthers) {
        const factor = availableForOthers / othersRawCtcTotal;
        // scale down other non-basic, non-special, non-sb items in first 2 sections
        scaled = scaled.map((sec, sIdx) => {
          if (sIdx < 2) {
            let sAnnual = 0;
            let sMonthly = 0;
            const newItems = sec.items.map((it) => {
              if (it.type === "basic") {
                const monthly = it.is_monthly ? finalBasicAnnual / 12 : null;
                sAnnual += finalBasicAnnual;
                sMonthly += monthly || 0;
                return { ...it, annual: finalBasicAnnual, monthly };
              } else if (it.type === "sb") {
                const monthly = it.is_monthly ? finalSBAnnual / 12 : null;
                sAnnual += finalSBAnnual;
                sMonthly += monthly || 0;
                return { ...it, annual: finalSBAnnual, monthly };
              } else if (it.type === "special") {
                return { ...it, annual: 0, monthly: null };
              } else {
                const newAnnual = (it.annual || 0) * factor;
                const newMonthly =
                  it.monthly !== null ? (it.monthly || 0) * factor : null;
                sAnnual += newAnnual;
                sMonthly += newMonthly || 0;
                return { ...it, annual: newAnnual, monthly: newMonthly };
              }
            });
            return {
              ...sec,
              items: newItems,
              sectionTotalAnnual: sAnnual,
              sectionTotalMonthly: sMonthly,
            };
          }
          return sec;
        });
      } else {
        // No scaling needed, keep initial as-is but ensure basic and sb are correctly assigned
        scaled = scaled.map((sec, sIdx) => {
          if (sIdx < 2) {
            const newItems = sec.items.map((it) => {
              if (it.type === "basic") {
                const monthly = it.is_monthly ? finalBasicAnnual / 12 : null;
                return { ...it, annual: finalBasicAnnual, monthly };
              }
              if (it.type === "sb") {
                const monthly = it.is_monthly ? finalSBAnnual / 12 : null;
                return { ...it, annual: finalSBAnnual, monthly };
              }
              return it;
            });
            const sumAnn = (a, i) => a + (i.annual || 0);
            const sumMon = (a, i) => a + (i.monthly || 0);
            return {
              ...sec,
              items: newItems,
              sectionTotalAnnual: newItems.reduce(sumAnn, 0),
              sectionTotalMonthly: newItems.reduce(sumMon, 0),
            };
          }
          return sec;
        });
      }
    }

    // Sum of sections 0-1 before special (Basic + HRA + Conveyance + SB)
    const ctcBeforeSpecial = scaled
      .slice(0, 2)
      .reduce((acc, sec) => acc + (sec.sectionTotalAnnual || 0), 0);

    // Special balances to Sample CTC.
    const remainingTarget = numericTotalCtc;
    let remaining = Math.max(0, remainingTarget - ctcBeforeSpecial);
    scaled = scaled.map((sec, sIdx) => {
      if (sIdx < 2) {
        let sAnnual = sec.sectionTotalAnnual || 0;
        let sMonthly = sec.sectionTotalMonthly || 0;
        const newItems = sec.items.map((it) => {
          if (it.type === "special") {
            if (remaining > 0) {
              const annual = remaining;
              const monthly = it.is_monthly ? annual / 12 : null;
              sAnnual += annual;
              sMonthly += monthly || 0;
              specialAmount = annual;
              remaining = 0;
              return { ...it, annual, monthly };
            } else {
              return { ...it, annual: 0, monthly: null };
            }
          }
          return it;
        });
        return {
          ...sec,
          items: newItems,
          sectionTotalAnnual: sAnnual,
          sectionTotalMonthly: sMonthly,
        };
      }
      return sec;
    });

    // Sections 0-1 sum (includes SB)
    const sections01Annual = scaled
      .slice(0, 2)
      .reduce((acc, sec) => acc + (sec.sectionTotalAnnual || 0), 0);
    const sections01Monthly = scaled
      .slice(0, 2)
      .reduce((acc, sec) => acc + (sec.sectionTotalMonthly || 0), 0);

    const sbAnnualSum = scaled
      .slice(0, 2)
      .reduce(
        (acc, sec) =>
          acc +
          sec.items
            .filter((it) => it.type === "sb")
            .reduce((s, it) => s + (it.annual || 0), 0),
        0,
      );

    // CTC Total = Sample CTC (includes SB), Gross Pay = CTC - SB, Company Contribution = sections 2+ only
    const ctcTotal = sections01Annual;
    const ctcTotalMonthly = sections01Monthly;
    const grossPayAnnual = ctcTotal - (sbPresent ? sbAnnualRaw : 0);
    const grossPayMonthly = grossPayAnnual / 12;

    const otherBenefitsBase = scaled
      .slice(2)
      .reduce((acc, sec) => acc + (sec.sectionTotalAnnual || 0), 0);
    const otherBenefitsBaseMonthly = scaled
      .slice(2)
      .reduce((acc, sec) => acc + (sec.sectionTotalMonthly || 0), 0);
    const otherBenefitsTotal = otherBenefitsBase;
    const otherBenefitsTotalMonthly = otherBenefitsBaseMonthly;

    // totalCompensation is the true total across everything
    const totalCompensation = ctcTotal + otherBenefitsTotal;

    // Return computed sections and totals
    return {
      sections: scaled,
      ctcTotal,
      ctcTotalMonthly,
      grossPayAnnual,
      grossPayMonthly,
      otherBenefitsTotal,
      otherBenefitsTotalMonthly,
      totalCompensation,
      specialPresent,
      basicPresent,
      specialAmount,
      sbPresent,
    };
  }, [sections, totalCtc]);

  // destructure
  const {
    sections: calcSections,
    ctcTotal,
    ctcTotalMonthly,
    otherBenefitsTotal,
    otherBenefitsTotalMonthly,
    totalCompensation,
    specialPresent,
    basicPresent,
    specialAmount,
    sbPresent,
  } = computedSections;

  const [singleSelects, setSingleSelects] = useState({
    basic: basicPresent,
    special: specialPresent,
    sb: sbPresent,
  });


  /**
   * Enhanced handleValueChange:
   * - clamps user input for items in first 2 sections so raw (unscaled) CTC breakup doesn't exceed Sample CTC.
   * - supports types: fixed, percentage, basic, fromBasic.
   */
  const handleValueChange = (sectionIndex, itemIndex, key, value) => {
    // If user toggles is_selected or edits name/type/is_monthly, apply directly
    if (key !== "value") {
      const updated = [...sections];
      updated[sectionIndex].items[itemIndex][key] = value;
      setSections(updated);
      return;
    }

    // For 'value' change we enforce clamping for items within first 2 sections
    const updated = [...sections];
    const item = { ...updated[sectionIndex].items[itemIndex] };
    const typedVal = value === "" ? "" : Number(value);
    if (value === "") {
      // allow clearing
      updated[sectionIndex].items[itemIndex].value = "";
      setSections(updated);
      return;
    }
    if (isNaN(typedVal) || typedVal < 0) {
      return; // ignore invalid input
    }

    // If the item is not in first two sections, accept freely
    if (sectionIndex >= 2) {
      updated[sectionIndex].items[itemIndex].value = typedVal;
      setSections(updated);
      return;
    }

    // Compute raw totals for first two sections excluding this item
    const numericTotalCtc = Number(totalCtc) || 0;

    // find basic current value (may be current item if editing basic)
    const findBasic = () => {
      for (let s = 0; s < sections.length; s++) {
        for (let it of sections[s].items) {
          if (it.is_selected && it.type === "basic") return it;
        }
      }
      return null;
    };

    const basicItem = findBasic();
    // compute raw annual helper identical to computeValueRaw earlier
    const computeRawAnnual = (
      it,
      valOverride = null,
      sbAnnualValue = currentSbAnnual,
    ) => {
      const type = it.type;
      const val =
        valOverride !== null ? Number(valOverride) || 0 : Number(it.value) || 0;
      const numericCtc = Number(totalCtc) || 0;
      const effectiveGross = Math.max(0, numericCtc - sbAnnualValue);

      switch (type) {
        case "percentage":
          return effectiveGross * (val / 100);
        case "fixed":
          return val;
        case "fromBasic": {
          const basicVal = basicItem ? Number(basicItem.value) || 0 : 0;
          const basicAnnual = effectiveGross * (basicVal / 100);
          return basicAnnual * (val / 100);
        }
        case "basic":
          return effectiveGross * (val / 100);
        case "sb":
          return numericCtc * (val / 100);
        case "special":
          return 0;
        default:
          return 0;
      }
    };

    // targets for clamping
    const currentSbItem = (() => {
      for (let s = 0; s < Math.min(2, sections.length); s++) {
        for (let itm of sections[s].items) {
          if (itm.is_selected && itm.type === "sb") return itm;
        }
      }
      return null;
    })();
    const currentSbAnnual = currentSbItem ? computeRawAnnual(currentSbItem) : 0;

    // If item is SB, it can occupy full numericTotalCtc space.
    // If not SB, it occupies space within (numericTotalCtc - SB).
    const targetBudgetAnnual =
      item.type === "sb"
        ? numericTotalCtc
        : Math.max(0, numericTotalCtc - currentSbAnnual);

    // sum raw annuals of other selected items in sections 0/1 excluding current and SB (since SB is handled by targetBudget)
    let rawSumExcludingCurrent = 0;
    for (let s = 0; s < Math.min(2, sections.length); s++) {
      const sec = sections[s];
      for (let i = 0; i < sec.items.length; i++) {
        const it = sec.items[i];
        if (!it.is_selected) continue;
        if (it.type === "sb") continue; // handled by targetBudget
        if (s === sectionIndex && i === itemIndex) continue; // exclude current
        rawSumExcludingCurrent += computeRawAnnual(it);
      }
    }

    // allowed annual left for this item (raw, unscaled)
    let allowedAnnual = Math.max(
      0,
      targetBudgetAnnual - rawSumExcludingCurrent,
    );

    // Compute candidate new annual for typedVal and clamp if needed:
    let candidateAnnual = computeRawAnnual(item, typedVal);

    if (candidateAnnual <= allowedAnnual + 0.000001) {
      // fits — accept typedVal
      updated[sectionIndex].items[itemIndex].value = typedVal;
      setSections(updated);
      return;
    }

    // candidate > allowed -> compute maximum allowed value depending on type and set it
    let clampedValue = 0;
    const type = item.type;
    if (type === "fixed") {
      clampedValue = Math.max(0, Math.floor(allowedAnnual)); // fixed amounts are rupees
    } else if (type === "percentage") {
      if (numericTotalCtc <= 0) clampedValue = 0;
      else clampedValue = (allowedAnnual / numericTotalCtc) * 100;
      // keep to 4 decimals to avoid extremely granular percentages
      clampedValue = Math.max(0, +clampedValue.toFixed(4));
    } else if (type === "basic") {
      if (numericTotalCtc <= 0) clampedValue = 0;
      else {
        // basic percent such that numericTotalCtc * percent/100 <= allowedAnnual
        clampedValue = (allowedAnnual / numericTotalCtc) * 100;
        clampedValue = Math.max(0, +clampedValue.toFixed(4));
      }
    } else if (type === "sb") {
      if (numericTotalCtc <= 0) clampedValue = 0;
      else {
        // sb percent such that numericTotalCtc * percent/100 <= allowedAnnual
        clampedValue = (allowedAnnual / numericTotalCtc) * 100;
        clampedValue = Math.max(0, +clampedValue.toFixed(4));
      }
    } else if (type === "fromBasic") {
      // depends on basic percent – compute basic annual
      const basicVal = basicItem ? Number(basicItem.value) || 0 : 0;
      const basicAnnual = numericTotalCtc * (basicVal / 100);
      if (basicAnnual <= 0) clampedValue = 0;
      else {
        clampedValue = (allowedAnnual / basicAnnual) * 100;
        clampedValue = Math.max(0, +clampedValue.toFixed(4));
      }
    } else {
      clampedValue = 0;
    }

    // apply clamped value and update state
    updated[sectionIndex].items[itemIndex].value = clampedValue;
    setSections(updated);
  };

  const handleSectionNameChange = (sectionIndex, value) => {
    const updated = [...sections];
    updated[sectionIndex].section = value;
    setSections(updated);
  };

  const handleAddItem = (sectionIndex) => {
    const updated = [...sections];
    updated[sectionIndex].items.push({
      name: "",
      type: "fixed",
      is_monthly: false,
      value: "",
      is_selected: true,
    });
    setSections(updated);
  };

  const handleRemoveItem = (sectionIndex, itemIndex) => {
    const updated = [...sections];
    updated[sectionIndex].items.splice(itemIndex, 1);
    setSections(updated);
  };

  if (isLoading) {
    return (
      <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-6">
        <div className="bg-white w-full max-w-6xl flex items-center justify-center rounded-xl shadow-2xl animate-fadeIn relative overflow-hidden">
          <FaSpinner className="animate-spin h-20 w-20 my-64 mx-24" />
        </div>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-6">
      {closeConfirmationModal ? (
        <CloseUnsaved
          onClose={onClose}
          onCancel={() => setCloseConfirmationModal(false)}
        />
      ) : (
        <div className="bg-white w-full max-w-6xl rounded-xl shadow-2xl animate-fadeIn relative overflow-hidden">
          <Button
            variant="icon"
            size="iconSm"
            className="!absolute top-4 right-4 border !bg-gray-50 rounded-full"
            onClick={onClose}
          >
            <MdClose />
          </Button>

          <div className="flex flex-col md:flex-row gap-2">
            <div className="flex-1 overflow-y-auto max-h-[70vh] relative p-6 border border-b-0 text-start">
              <div className="mb-3">
                <h2 className="text-sm font-semibold text-primaryBlack">
                  Template Name
                </h2>
                <Input
                  type="text"
                  placeholder="Template Name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  maxLength={100}
                />
              </div>
              <div className="flex bg-[#EFF1F5] sticky -top-5 z-10 text-[#000]/50 py-2 text-sm font-semibold">
                <div className="w-[40%] pl-4">PARTICULARS</div>
                <div className="w-[60%] flex">
                  <div className="w-full flex gap-2 items-center">
                    CALCULATION TYPE
                  </div>
                  <div className="w-full text-end pr-4">AMOUNT</div>
                </div>
              </div>
              {sections.map((section, sectionIndex) => {
                return (
                  <SalarySectionComponent
                    key={sectionIndex}
                    sectionIndex={sectionIndex}
                    section={section}
                    handleAddItem={handleAddItem}
                    handleRemoveItem={handleRemoveItem}
                    handleValueChange={handleValueChange}
                    singleSelects={singleSelects}
                    setSingleSelects={setSingleSelects}
                    specialAmount={specialAmount}
                    handleSectionNameChange={handleSectionNameChange}
                  />
                );
              })}
            </div>

            {/* RIGHT: Summary */}
            <div className="w-full max-h-[70vh] overflow-auto md:w-1/3 border p-4 bg-gray-50">
              <h3 className="text-lg text-left font-semibold mb-1">
                Sample CTC*
              </h3>
              <Input
                placeholder="10,00,000"
                value={totalCtc}
                onChange={(e) => setTotalCtc(e.target.value)}
                type="number"
                onKeyDown={(e) => {
                  const forbiddenKeys = ["+", "-", "=", "e", "E"];
                  if (forbiddenKeys.includes(e.key)) {
                    e.preventDefault();
                  }
                }}
              />
              <p className="text-xs text-gray-500 mt-2 text-left mb-3">
                Only for calculation purposes
              </p>

              <div className="mt-4 space-y-4 text-sm">
                <div className="grid grid-cols-3 text-primaryBlack font-semibold text-start items-center">
                  <span>Section</span>
                  <span className="text-end">Monthly</span>
                  <span className="text-end">Annual</span>
                </div>
              </div>

              <div className="mt-4 space-y-4 text-sm">
                {/* Only show sections with non-zero annual totals in the "calculation" view */}
                {calcSections
                  .slice(0, 2)
                  .filter((section) => (section.sectionTotalAnnual || 0) > 0)
                  .map((section, i) => (
                    <div key={i}>
                      <div className="grid grid-cols-3 text-primaryBlack font-semibold items-center border-t py-2">
                        <h4 className="text-start">{section.section}</h4>
                        <span className="text-right">
                          {formatCurrency(section.sectionTotalMonthly || 0)}
                        </span>
                        <span className="text-right">
                          {formatCurrency(section.sectionTotalAnnual || 0)}
                        </span>
                      </div>
                      <div className="">
                        {section.items
                          .filter((it) => (it.annual || 0) > 0)
                          .map((item, j) => (
                            <div
                              key={j}
                              className="grid grid-cols-3 text-gray-700 items-center border-t py-2"
                            >
                              <span className="text-start">{item.name}</span>
                              <span className="text-right">
                                {item.monthly !== null
                                  ? formatCurrency(item.monthly || 0)
                                  : formatCurrency(0)}
                              </span>
                              <span className="text-right">
                                {formatCurrency(item.annual || 0)}
                              </span>
                            </div>
                          ))}
                      </div>
                    </div>
                  ))}

                {ctcTotal > 0 && (
                  <div className="grid text-left grid-cols-3 gap-2 border-t py-2 text-primaryBlack items-center font-bold">
                    <span>CTC Total</span>
                    <span className="text-end">
                      {formatCurrency(ctcTotalMonthly)}
                    </span>
                    <span className="text-end">{formatCurrency(ctcTotal)}</span>
                  </div>
                )}

                {otherBenefitsTotal > 0 && sections[2] && (
                  <div className="grid text-left grid-cols-3 gap-2 font-bold border-t py-2 text-primaryBlack items-center">
                    <span>{sections[2].section}</span>
                    <span className="text-end">
                      {formatCurrency(otherBenefitsTotalMonthly)}
                    </span>
                    <span className="text-end">
                      {formatCurrency(otherBenefitsTotal)}
                    </span>
                  </div>
                )}

                {calcSections
                  .slice(2)
                  .filter((section) => (section.sectionTotalAnnual || 0) > 0)
                  .map((section, i) => (
                    <div key={i}>
                      <div className="">
                        {section.items
                          .filter((it) => (it.annual || 0) > 0)
                          .map((item, j) => (
                            <div
                              key={j}
                              className="grid grid-cols-3 text-gray-700 items-center border-t py-2"
                            >
                              <span className="text-start">{item.name}</span>
                              <span className="text-right">
                                {item.monthly !== null
                                  ? formatCurrency(item.monthly || 0)
                                  : formatCurrency(0)}
                              </span>
                              <span className="text-right">
                                {formatCurrency(item.annual || 0)}
                              </span>
                            </div>
                          ))}
                      </div>
                    </div>
                  ))}

                <div className="grid text-left grid-cols-3 gap-2 border-t py-2 text-primaryBlack items-center font-bold">
                  <span>Total</span>
                  <span className="text-end">
                    {formatCurrency(totalCompensation / 12)}
                  </span>
                  <span className="text-end">
                    {formatCurrency(totalCompensation)}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-center border-t bg-gray-50 px-6 py-4 rounded-b-xl gap-3">
            <Button
              variant="secondary"
              onClick={() => setCloseConfirmationModal(true)}
            >
              Close
            </Button>
            <Button
              variant="black"
              onClick={() => {
                if (!isEdit) {
                  refetch().then(() => window.location.reload());
                } else updateRefetch().then(() => window.location.reload());
              }}
              disabled={
                name.trim().length < 3 ||
                sections.some(
                  (item) =>
                    item.section.trim().length < 3 ||
                    item.items.some((it) => it.name.trim().length < 3),
                )
              }
            >
              Save
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SalaryModal;
